<template>
  <div class="table-responsive">
    <table
      class="table table-striped table-sm table-bordered"
      :id="dataTable.id"
    >
      <thead>
        <tr>
          <th>Nome</th>
          <th>E-mail</th>
          <th class="text-center">Tipo</th>
          <th class="text-center">Status</th>
          <th>Perfis</th>
          <th class="text-center">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="user in users" :key="user.id">
          <td>{{ user.nome }}</td>
          <td>{{ user.email }}</td>
          <td class="text-center" v-html="tipoUsuarioTranslate(user.tipo)" />
          <td class="text-center" v-html="statusTranslate(user.status)" />
          <td>
            <p v-for="userProfile in user.userProfiles" :key="userProfile.id">
              {{ userProfile.perfilNome }}
            </p>
          </td>
          <td class="text-center p-2">
            <button
              type="button"
              class="btn btn-outline-danger btn-icon"
              title="Excluir"
              @click="$emit('deleteUser', user.id)"
            >
              <i class="ph ph-trash" />
            </button>
            <button
              type="button"
              class="btn btn-outline-warning btn-icon ms-2"
              title="Editar"
              @click="$emit('createEditUser', user.id)"
            >
              <i class="ph ph-pencil" />
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import '@/utils/basicDataTableExtend'
import { tipoUsuarioTranslate, statusTranslate } from '@/utils/strings'

export default {
  name: 'ListUsers',

  props: {
    users: {
      type: Array,
      required: true,
    },
  },

  emits: ['createEditUser', 'deleteUser'],

  data() {
    return {
      table: null,
      dataTable: {
        id: 'dataTableListUsers',
        columnDefs: [
          {
            targets: [5],
            width: 130,
            orderable: false,
          },
        ],
      },
      tipoUsuarioTranslate,
      statusTranslate,
    }
  },

  methods: {
    createDataTable() {
      if (this.table) {
        this.table.destroy()
      }
      this.table = window.$(`#${this.dataTable.id}`).DataTable({
        columnDefs: this.dataTable.columnDefs,
      })
    },
  },

  mounted() {
    this.createDataTable()
  },
}
</script>
